import { PageHero } from "@/components/site/PageHero";
import { SectionHead } from "@/components/site/SectionHead";
import { StagesFlow } from "@/components/journey/StagesFlow";
import { DayPanel, PracticalDetails } from "@/components/journey/HowItWorks";
import { Faq } from "@/components/journey/Faq";
import { JourneyInvitation } from "@/components/journey/JourneyInvitation";
import { ContactButton } from "@/components/site/ContactButton";
import { Reveal } from "@/components/site/Motion";
import { Petal } from "@/components/site/Petal";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { STAGES } from "@/lib/content";

export default function Journey() {
  return (
    <div data-testid="journey-page">
      <PageHero
        testId="journey-hero"
        eyebrow="The 21-day journey"
        badge="21-Day Coaching Journey • Coming Soon • 1:1 Coaching Available Now"
        lines={["Twenty-one days,", <em key="l" className="text-[#7a5615]">five layers,</em>, "one way home."]}
        text="The Panchmaya coaching program is a gentle, structured journey through the five koshas, moving from the body you live in to a quieter sense of connection. While the full 21-day guided program is being prepared for release, you can experience these practices today through personalized 1:1 coaching sessions with Sheetal."
      >
        <WhatsAppButton testId="journey-hero-whatsapp-btn">Inquire About 1:1 Coaching</WhatsAppButton>
        <ContactButton testId="journey-hero-contact-btn" variant="outline" size="large" />
      </PageHero>

      <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8 md:py-32 lg:px-12" data-testid="journey-stages">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <SectionHead
            size="large"
            eyebrow="The five stages"
            title="From the outer layer to the innermost"
            text="Each stage focuses on one kosha, or layer of experience. Together they trace the movement at the heart of Panchmaya: from heaviness, through awareness, toward light."
          />
          <Reveal className="flex items-center justify-center gap-2 sm:justify-start" delay={0.2}>
            {STAGES.map((s) => <Petal key={s.n} color={s.color} size={18} />)}
          </Reveal>
        </div>
        <div className="mt-16">
          <StagesFlow stages={STAGES} />
          <Reveal className="grid gap-6 border-t border-[#e4dacb] py-14 md:grid-cols-[96px_minmax(0,1fr)] md:gap-8 lg:grid-cols-[112px_minmax(0,1fr)] lg:gap-12" >
            <span className="font-display text-center text-7xl leading-none text-[#a8792a] sm:text-left md:text-8xl">21</span>
            <div data-testid="journey-stage-integration">
              <h3 className="font-display text-center text-[2.5rem] font-medium leading-tight text-[#221e1b] sm:text-left sm:text-5xl">Bringing it together</h3>
              <p className="mt-4 max-w-2xl text-[1.0625rem] leading-[1.75] text-[#5d544c] sm:text-lg">
                A final day to look back across all five layers, notice what has shifted, and choose
                what you&apos;d like to carry forward into everyday life.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#f2ebe0] py-24 md:py-32" data-testid="journey-how">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
          <SectionHead size="large" eyebrow="How the journey works" title="A simple daily rhythm"
            text="Each day follows a gentle rhythm, short enough to fit into ordinary life." />
          <div className="mt-14 grid items-stretch gap-6 lg:grid-cols-[1.15fr_1fr]">
            <DayPanel />
            <PracticalDetails />
          </div>
        </div>
      </section>

      <Faq />

      <JourneyInvitation />
    </div>
  );
}
